import { Component, Input, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-metabolic-calc-results',
  templateUrl: './metabolic-calc-results.component.html',
  styleUrls: ['./metabolic-calc-results.component.scss']
})
export class MetabolicCalcResultsComponent implements OnInit {
  @Input() calcResults: any = {};
  tableData: any;
  constructor(private translateSrv: TranslateService, private activatedRouter: ActivatedRoute) {}

  ngOnInit() {
    this.prepareResultData();
  }
  prepareResultData() {
    this.tableData = {
      stickyColsStart: 2,
      stickyColsEnd: 1,
      headerValues: [' ', 'RATE.TTL-HEADER-RISK'],
      values: [
        {
          id: this.calcResults.result.id,
          values: ['', 'TITLES.METABOLIC-CALCULATOR']
        }
      ]
    };
    this.calcResults.result.cobertura.map((coverage: any) => {
      this.tableData.headerValues.push(this.translateSrv.instant(`RATE.COBERTURAS.${coverage.id}`));
      this.tableData.values[0].values.push(coverage.valor);
    });
  }
  cartDisclaimer(): boolean {
    const idCaseParam = this.activatedRouter.snapshot.paramMap.get('idCase');

    let idCaseStorage: any;

    try {
      const parsedData = JSON.parse(localStorage.getItem('CASE_IN_COURSE') || '{}');
      idCaseStorage = parsedData?.idCase || null;
    } catch (e) {
      idCaseStorage = null;
    }

    // console.log('Param: ', idCaseParam, 'Storage: ', idCaseStorage);

    // Caso en el que ambos tienen algún valor pero son distintos: no debemos almacenar el calculador de un caso parametrizado en el caso en curso
    if (idCaseStorage !== null && idCaseParam !== null && idCaseStorage !== idCaseParam) {
      return true;
    } else {
      // En todos los demás casos permitimos
      return false;
    }
  }

  getGlycemicTreatment(treatmentList: string[]): string {
    const treatments = [];
    for (const treatment of treatmentList) {
      if (treatment === 'insulina') {
        treatments.push(this.translateSrv.instant('METABOLIC-CALC.INSULIN'));
      }
      if (treatment === 'oral-others') {
        treatments.push(this.translateSrv.instant('METABOLIC-CALC.ORAL-OTHERS'));
      }
      if (treatment === 'diet') {
        treatments.push(this.translateSrv.instant('METABOLIC-CALC.DIET'));
      }
    }
    return treatments.join(', ');
  }

  getCardiacTreatment(treatment: string) {
    switch (treatment) {
      case 'MYOCARDIAL_INFARCTION':
        return this.translateSrv.instant('METABOLIC-CALC.CARDIAC-PROFILE.MYOCARDIAL_INFARCTION');
      case 'CORONARY_HEART_DISEASE':
        return this.translateSrv.instant('METABOLIC-CALC.CARDIAC-PROFILE.CORONARY_HEART_DISEASE');
      case 'MEDICAL_TREATMENT':
        return this.translateSrv.instant('METABOLIC-CALC.CARDIAC-PROFILE.MEDICAL_TREATMENT');
      case 'SURGICAL_TREATMENT':
        return this.translateSrv.instant('METABOLIC-CALC.CARDIAC-PROFILE.SURGICAL_TREATMENT');
      case 'BYPASS':
        return this.translateSrv.instant('METABOLIC-CALC.CARDIAC-PROFILE.BYPASS');
      case 'WITH_STENT_OR_PCI':
        return this.translateSrv.instant('METABOLIC-CALC.CARDIAC-PROFILE.WITH_STENT_OR_PCI');
      case 'ONE_OFF_EPISODE':
        return this.translateSrv.instant('METABOLIC-CALC.CARDIAC-PROFILE.ONE_OFF_EPISODE');
      case 'MORE_THAN_ONE_EPISODE':
        return this.translateSrv.instant('METABOLIC-CALC.CARDIAC-PROFILE.MORE_THAN_ONE_EPISODE');
      case 'INVOLVEMENT_OF_1_VESSEL':
        return this.translateSrv.instant('METABOLIC-CALC.CARDIAC-PROFILE.INVOLVEMENT_OF_1_VESSEL');
      case 'INVOLVEMENT_OF_2_VESSELS_OR_MAIN_TRUNK_INVOLVEMENT':
        return this.translateSrv.instant('METABOLIC-CALC.CARDIAC-PROFILE.INVOLVEMENT_OF_2_VESSELS_OR_MAIN_TRUNK_INVOLVEMENT');
      case 'INVOLVEMENT_OF_3_OR_MORE_VESSELS':
        return this.translateSrv.instant('METABOLIC-CALC.CARDIAC-PROFILE.INVOLVEMENT_OF_3_OR_MORE_VESSELS');
      default:
        return '';
    }
  }

  getCardiacComplication(complicationsList: string[]) {
    const complications = [];
    for (const complication of complicationsList) {
      if (complication?.includes('ARRHYTHMIAS')) {
        complications.push(this.translateSrv.instant('METABOLIC-CALC.CARDIAC-PROFILE.ARRHYTHMIAS'));
      }
      if (complication?.includes('VALVE_DISEASE')) {
        complications.push(this.translateSrv.instant('METABOLIC-CALC.CARDIAC-PROFILE.VALVE_DISEASE'));
      }
      if (complication?.includes('CEREBROVASCULAR_DISEASE')) {
        complications.push(this.translateSrv.instant('METABOLIC-CALC.CARDIAC-PROFILE.CEREBROVASCULAR_DISEASE'));
      }
      if (complication?.includes('PERIPHERAL_VASCULAR_DISEASE')) {
        complications.push(this.translateSrv.instant('METABOLIC-CALC.CARDIAC-PROFILE.PERIPHERAL_VASCULAR_DISEASE'));
      }
      if (complication?.includes('LEFT_VENTRICULAR_HYPERTROPHY')) {
        complications.push(this.translateSrv.instant('METABOLIC-CALC.CARDIAC-PROFILE.LEFT_VENTRICULAR_HYPERTROPHY'));
      }
    }
    return complications.join(', ');
  }
}
